import React from 'react'

import clsx from 'clsx'

interface FieldProps {
  children: React.ReactNode
  error?: string
  htmlFor?: string
  label: string
}

export const Field: React.FC<FieldProps> = ({ children, error, htmlFor, label }) => {
  const errorId = htmlFor ? `${htmlFor}-error` : undefined

  return (
    <div className={clsx('user-profile-field', error && 'user-profile-field_invalid')}>
      <label className="user-profile-field__label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error ? (
        <p className="user-profile-field__error" id={errorId} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  )
}
